module.exports = __webpack_public_path__ + "img/cafeteria-menu-template-editable.59941d09.jpg";